import angular from "angular";
import CartModule from '../cart/cart';
import FastPurchaseModule from '../fast-purchase/fast-purchase';
// import ConfimationOrderModule from '../confirmation-order/confirmation-order';
import OrdersModule from '../orders/orders';
import BlogModule from '../blog/blog';
import SalesHomeModule from '../sales-home/sales-home';
import TunelModule from '../tunnel/tunnel';
import CatalogModule from '../catalog/catalog';
import AccountModule from '../account/account';
import AddressModule from '../address/address';
import ContactDetailModule from '../contact-detail/contact-detail';
import AuthModule from '../auth/auth';
import textBoxTemplateModule from '../box-text-template/box-text-template';
import BoxPostByCategory from '../catalog/category/box-post-by-category/box-post-by-category';

let B2bB2cAplicationModule = angular.module('b2bB2cAplication', [
    CartModule.name,
    FastPurchaseModule.name,
    // ConfimationOrderModule.name,
    SalesHomeModule.name,
    TunelModule.name,
    CatalogModule.name,
    AccountModule.name,
    OrdersModule.name,
    BlogModule.name,
    AddressModule.name,
    ContactDetailModule.name,
    AuthModule.name,
    textBoxTemplateModule.name,
    BoxPostByCategory.name,
]);

export default B2bB2cAplicationModule;



// WEBPACK FOOTER //
// ./www/components/b2b-b2c-aplication/b2b-b2c-aplication.js